module.exports = "/public/webpack/img/icon_help_contact3fb0576bec4dbd9a26443bc9659b8890.png";